export const enDateFormat = 'MM/dd/yyyy';
export const deDateFormat = 'dd.MM.yyyy';

export const enDateTimeFormat = 'MM/dd/yyyy HH:mm';
export const deDateTimeFormat = 'dd.MM.yyyy HH:mm';
